import { MessageSourceProps, withMessages } from 'react-message-source';
import React, { Component } from 'react';
import { MediDataNotificationResponseDto } from 'ts-types/api.types';
import { Grid, List } from 'semantic-ui-react';
import PxGrid from 'components/layout/PxGrid';
import styled from 'styled-components';
import moment from 'moment';

const StyledDiv = styled.div`
  margin-left: 1rem;
`

interface Props extends MessageSourceProps {
  notification: MediDataNotificationResponseDto,
  language: string
}

interface State {
}

class MediDataNotificationDetailsModal extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

  }

  render(): React.ReactNode {
    const {notification, language, getMessage} = this.props;

    return (
        <PxGrid>
          <Grid.Row style={{marginTop: '1rem'}}>
            <Grid.Column width={1}>
              <div>{getMessage("mediDataNotifications.tableHeader.created")}:</div>
            </Grid.Column>
            <Grid.Column width={15}>
              <StyledDiv>{moment(notification.created).format("DD.MM.YYYY")}</StyledDiv>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={1}>
              <label>{getMessage("mediDataNotifications.subject")}: </label>
            </Grid.Column>
            <Grid.Column width={15}>
              <StyledDiv>{notification.subject[language]}</StyledDiv>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{marginBottom: '1rem'}}>
            <Grid.Column width={1}>
              <label>{getMessage("mediDataNotifications.severity")}: </label>
            </Grid.Column>
            <Grid.Column width={15}>
              <StyledDiv>{notification.severity}</StyledDiv>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              {getMessage("mediDataNotifications.references")}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{marginBottom: '1rem'}}>
            <Grid.Column width={16}>
              <List bulleted style={{marginLeft: '4rem'}}>
                <List.Item style={{display: 'flex'}}>
                  <label>{getMessage("mediDataNotifications.documentReference")}: </label>
                  <Grid.Column>
                    <StyledDiv>{notification.documentReference}</StyledDiv>
                  </Grid.Column>
                </List.Item>
                <List.Item style={{display: 'flex'}}>
                  <label>{getMessage("mediDataNotifications.correlationReference")}: </label>
                  <StyledDiv>{notification.correlationReference}</StyledDiv>
                </List.Item>
                <List.Item style={{display: 'flex'}}>
                  <label>{getMessage("mediDataNotifications.transmissionReference")}: </label>
                  <StyledDiv>{notification.transmissionReference}</StyledDiv>
                </List.Item>
              </List>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              {getMessage("mediDataNotifications.information")}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{marginBottom: '1rem'}}>
            <Grid.Column width={16}>
              <List bulleted style={{marginLeft: '4rem'}}>
                <List.Item style={{display: 'flex'}}>
                  <label>{getMessage("mediDataNotifications.potentialReasons")}: </label>
                  <StyledDiv>{notification.possibleSolutions[language]}</StyledDiv>
                </List.Item>
                <List.Item style={{display: 'flex'}}>
                  <label>{getMessage("mediDataNotifications.correlationReference")}: </label>
                  <StyledDiv>{notification.possibleSolutions[language]}</StyledDiv>
                </List.Item>
              </List>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              {getMessage("mediDataNotifications.support")}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{marginBottom: '1rem'}}>
            <Grid.Column width={16}>
              <List bulleted style={{marginLeft: '4rem'}}>
                <List.Item style={{display: 'flex'}}>
                  <label>{getMessage("mediDataNotifications.errorCode")}: </label>
                  <StyledDiv>{notification.errorCode}</StyledDiv>
                </List.Item>
                <List.Item style={{display: 'flex'}}>
                  <label>{getMessage("mediDataNotifications.technicalInformation")}: </label>
                  <StyledDiv>{notification.technicalInformation}</StyledDiv>
                </List.Item>
              </List>
            </Grid.Column>
          </Grid.Row>
        </PxGrid>
    );
  }

}

export default withMessages(MediDataNotificationDetailsModal);
